import { FolhasPerfilTable } from './folhas-perfil-table';
import { useEstagiarioFolhasPerfil } from './useEstagiarioFolhasPerfil';

type FolhasPerfilTabProps = {
  estagiarioId?: number;
};

export function FolhasPerfilTab({ estagiarioId }: FolhasPerfilTabProps) {
  const { folhas, carregando, recarregar, permissaoExcluirFolhas } = useEstagiarioFolhasPerfil(
    estagiarioId,
    true,
  );

  if (!estagiarioId) {
    return (
      <p className="text-muted small mb-0 py-1">
        Salve o cadastro do estagiário para visualizar as folhas de frequência.
      </p>
    );
  }

  return (
    <FolhasPerfilTable
      folhas={folhas}
      carregando={carregando}
      emptyMessage="Nenhuma folha de frequência criada para este estagiário."
      permissaoExcluirFolhas={permissaoExcluirFolhas}
      onExcluida={recarregar}
    />
  );
}
